module.exports = "/images/alipay.svg";